var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-root",class:[_vm.hideOverflow && 'hide-overflow']},[(_vm.header)?_c('div',{staticClass:"pl-4 d-flex align-items-center justify-content-between",class:{
            'py-2': !_vm.tall && !_vm.noHeaderPadding,
            'py-3': (_vm.tall || !_vm.tall) && !_vm.noHeaderPadding,
            'pr-3': !_vm.noHeaderPadding,
        }},[_c('h6',{staticClass:"subtitle bold heading mb-0",style:({
                'max-width': _vm.restrictHeaderWidth ? '90%' : null,
                'margin-left': _vm.offsetHeaderFromLeft ? '50px' : 'none',
            })},[_vm._v("\n            "+_vm._s(_vm.header)+"\n        ")]),_vm._t("header")],2):_vm._e(),(_vm.header)?_c('Divider'):_vm._e(),(_vm.padding || _vm.customPadding)?_c('div',{class:`${
                _vm.customPadding != ''
                    ? _vm.customPadding
                    : 'p-' + (_vm.shouldUseDefaultPadding ? '2' : _vm.padding)
            } w-100`},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }